import React from "react";

interface TransferHistoryRowProps {
    item: {
        code: string;
        created_at: string | Date;
        sender_name: string;
        from_location_name: string;
        to_location_name: string;
        is_approved: boolean;
        receiver_name?: string | null;
    };
    onDetailClick: (code: string) => void;
}

const TransferHistoryRow: React.FC<TransferHistoryRowProps> = ({
    item,
    onDetailClick,
}) => {
    return (
        <tr key={item.code}>
            <td className="border border-slate-700 p-2">
                {new Date(item.created_at).toLocaleDateString([], {
                    hour12: false,
                })}{" "}
                {new Date(item.created_at).toLocaleTimeString([], {
                    hour12: false,
                })}
            </td>
            <td className="border border-slate-700 p-2">{item.code}</td>
            <td className="border border-slate-700 p-2">{item.sender_name}</td>
            <td className="border border-slate-700 p-2">
                {item.from_location_name}
            </td>
            <td className="border border-slate-700 p-2">
                {item.to_location_name}
            </td>
            <td className="border border-slate-700 p-2">
                {item.is_approved ? (
                    <span className="text-green-500 font-semibold">
                        &#10003;
                    </span>
                ) : (
                    <span className="text-red-500 font-semibold">&#10007;</span>
                )}
            </td>
            <td className="border border-slate-700 p-2">
                {item.receiver_name ?? "-"}
            </td>
            <td className="border border-slate-700 p-2">
                <button
                    className="bg-indigo-400 text-white px-2 py-1 rounded"
                    onClick={() => onDetailClick(item.code)}
                >
                    Detail
                </button>
            </td>
        </tr>
    );
};

export default TransferHistoryRow;
